<template>
    <div class="h-100">
        <div
            v-for="product_story in product_stories"
            :key="product_story.id"
            class="row justify-content-center"
        >
            <div class="col-10 justify-content-center">
                <img class="img-fluid" :src="product_story.file" />
            </div>

            <div class="col-12 mt-4">
                <div class="row justify-content-center">
                    <h3 class="col-12 text-center">
                        <strong>{{ product_story.title }}</strong>
                    </h3>
                </div>
                <div
                    v-for="(text, index) in product_story.text.split('<br>')"
                    :key="index"
                    class="row justify-content-center"
                >
                    <div class="col-10 mt-2 ml-5 mr-5">
                        <p class="text-center" v-html="text"></p>
                    </div>
                </div>
            </div>

            <!-- Modal to display error message -->
            <b-modal
                id="modal-error"
                size="sm"
                title="Something went wrong :("
                hide-footer
            >
                <template>
                    <div class="d-flex justify-content-between flex-column">
                        <h6>{{ errorMessage }}</h6>
                    </div>
                </template>
            </b-modal>

            <div class="col-12 pb-4 mb-5 align-items-center">
                <div class="row justify-content-center">
                    <p class="col-3 text-center">
                        <strong>Go to</strong>
                    </p>
                </div>
                <div class="row justify-content-center">
                    <button
                        class="col-4 py-2"
                        style="
                            background-color: #f6d384;
                            border: none;
                            color: #050365;
                        "
                    >
                        <strong>Passport</strong>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
  components: {},
  props: {
    product_stories: {
      type: Array,
      default: null,
      required: true
    }
  },
  data() {
    return {
      searchText: "",
      errorMessage: "",
      showButton: true
    };
  },
  destroyed() {
    window.removeEventListener("scroll", this.listener);
  },
  computed: {},
  mounted() {
    this.listener = () => {
      this.showButton = !window.pageYOffset > 0;
    };
    window.addEventListener("scroll", this.listener);
  },
  methods: {}
};
</script>

<style scoped lang="scss">
#app .b-table .sr-only {
  display: none;
}

p,
pre {
  font-size: 1em !important;
  color: #17253c !important;
  font-family: Lato, sans-serif !important;
}

h3,
h5 {
  color: #17253c;
  font-family: Lato, sans-serif !important;
}

.test {
  position: fixed;
  bottom: 0px;
  left: 0px;
  background: #f8f9fa;
}

.fade-enter-active {
  transition: all 0.5s;
}

.fade-leave-active {
  transition: all 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

::placeholder {
  color: white;
}
</style>

<style lang="scss" scoped />
